import axios from "axios";

import config from "@app/config";

export const addToCart = async ({ id, qty, properties }: { id: number; qty: number, properties?: any }) => {
  const res = await axios({
    method: "POST",
    url: "/cart/add.js",
    data: JSON.stringify({
      id: id,
      quantity: qty,
      properties: properties || {}
    }),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  })
    .then((result) => {
      if (result.status === 200) {
        // Always increment a successful cart purchase
        document.querySelectorAll("[data-cart-count]")?.forEach((x) => (x.innerText = parseInt(x.innerText) + 1));
        const event = new CustomEvent("cartAdd");

        if (window.location.pathname !== "/cart") {
          window.dispatchEvent(event);
        } else {
          location.reload();
        }
      }
      return result;
    })
    .catch((error) => error.response.data);

  return res;
};

export const updateCart = async ({ id, qty }: { id: number; qty: number }) => {
  const res = await axios({
    method: "POST",
    url: "/cart/update.js",
    data: JSON.stringify({
      updates: {
        [id]: qty
      },
    }),
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  })
    .then((result) => {
      if (result.status === 200) {
        // Always update a successful cart purchase
        if (!isNaN(result?.data?.item_count))
          document.querySelectorAll("[data-cart-count]")?.forEach((x) => (x.innerText = result.data.item_count));
      }
      return result;
    })
    .catch((error) => error.response.data);

  return res;
};

export const addToBackInStock = async ({
  email,
  variantId,
  productId,
}: {
  email: string;
  variantId: number;
  productId: number;
}) => {
  const res = await axios
    .post(
      "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      {
        a: config.keys.klaviyoId,
        g: "KPRSPb",
        product: `${productId}`,
        variant: `${variantId}`,
        email: email,
        platform: "shopify",
      },
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((result) => result)
    .catch((error) => error?.response?.data);

  return res;
};

export const formatPrice = (price: number, countryCode = "AUD") => {
  const f = new Intl.NumberFormat("en-" + countryCode.slice(0, 2), {
    style: "currency",
    currency: countryCode,
  });

  return f.format(price);
};

export const stripColourFromVariantTitle = (title: string) => {
  if (!title) return "";
  const parts = title.split("/");
  const lastPart = parts[parts.length - 1].trim();
  return lastPart;
};